import { useState } from "react";
import { Link } from "react-router-dom";
import { Fingerprint, MailCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md bg-white rounded-2xl border p-8 shadow-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-2xl bg-emerald-900 flex items-center justify-center">
            <Fingerprint className="w-6 h-6 text-amber-400" />
          </div>
          <h1 className="text-lg font-extrabold text-emerald-950">استعادة كلمة المرور</h1>
        </div>
        {done ? (
          <div className="text-center space-y-3" data-testid="forgot-success-message">
            <MailCheck className="w-12 h-12 text-emerald-700 mx-auto" />
            <p className="text-sm text-slate-600 leading-7">
              إذا كان البريد مسجلاً لدينا، ستصلك رسالة تحتوي رابط إعادة التعيين خلال دقائق.
              تحقق من صندوق الوارد والرسائل غير المرغوبة.
            </p>
            <Link to="/login" className="text-emerald-800 text-sm font-semibold hover:underline">
              العودة لتسجيل الدخول
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-500">أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة تعيين كلمة المرور.</p>
            <div className="space-y-1.5">
              <Label htmlFor="email">البريد الإلكتروني</Label>
              <Input id="email" type="email" dir="ltr" data-testid="forgot-email-input" value={email}
                onChange={(e) => setEmail(e.target.value)} required placeholder="name@example.com" />
            </div>
            {error && (
              <div data-testid="forgot-error-alert"
                className="text-sm bg-rose-50 text-rose-700 border border-rose-200 rounded-lg px-3 py-2">
                {error}
              </div>
            )}
            <Button type="submit" data-testid="forgot-submit-button" disabled={loading}
              className="w-full bg-emerald-900 hover:bg-emerald-950 text-white h-11">
              {loading ? "جارٍ الإرسال..." : "إرسال رابط الاستعادة"}
            </Button>
            <p className="text-center">
              <Link to="/login" className="text-sm text-emerald-800 hover:underline">العودة لتسجيل الدخول</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
